import { useSelector } from 'react-redux';
import tinycolor from 'tinycolor2';
import { FILE_HOST } from 'shared/constants/appConfig';
import {
  DEFAULT_SECONDARY_COLOUR,
} from 'shared/constants/styleConstants';
import { displayDate } from 'shared/helpers/common';

export default function useWhiteLabelSettings() {
  const { whiteLabelSettings: whiteLabel = {} } = useSelector(
    (state) => state.ui,
  );
  const actualWhiteLabel = {};

  const hasImage = (image) => {
    if (!image) {
      return false;
    }

    const tempImage = `${image}`.trim();
    const imageValue =
      tempImage.lastIndexOf('?token') !== -1
        ? tempImage.substring(0, tempImage.lastIndexOf('?token'))
        : '';

    return imageValue !== 'null';
  };

  const {
    loginLogo,
    loginImage,
    overviewLogo,
    overviewImage,
    overviewLogoLarge = false,
    primaryColour,
    secondaryColour,
    copyrightMessage = '',
    email = '',
    phoneNumber = '',
    website = '',
  } = whiteLabel;

  actualWhiteLabel.copyrightMessage =
    copyrightMessage ||
    `Copyright © ${displayDate(
      new Date().getTime(),
      '',
      'yyyy',
    )}. All rights reserved.`;
  actualWhiteLabel.email = email;
  actualWhiteLabel.phoneNumber = phoneNumber;
  actualWhiteLabel.website = website;

  actualWhiteLabel.loginLogo = hasImage(loginLogo)
    ? `${FILE_HOST}${loginLogo}`
    : '';
  actualWhiteLabel.loginImage = hasImage(loginImage)
    ? `${FILE_HOST}${loginImage}`
    : '';

  actualWhiteLabel.overviewLogo = hasImage(overviewLogo)
    ? `${FILE_HOST}${overviewLogo}`
    : '';
  actualWhiteLabel.overviewImage = hasImage(overviewImage)
    ? `${FILE_HOST}${overviewImage}`
    : '';
  actualWhiteLabel.overviewLogoLarge = overviewLogoLarge;

  actualWhiteLabel.primaryColour = primaryColour;
  actualWhiteLabel.secondaryColour =
    secondaryColour || DEFAULT_SECONDARY_COLOUR;

  actualWhiteLabel.secondaryColourNoFallBack = secondaryColour;

  actualWhiteLabel.secondaryColourDarker = tinycolor(
    actualWhiteLabel.secondaryColour,
  )
    .darken(7)
    .toString();

  actualWhiteLabel.secondaryColourLighter = secondaryColour
    ? tinycolor(actualWhiteLabel.secondaryColour).lighten(15).toString()
    : '#39C5E7';

  actualWhiteLabel.primaryColourLighter = tinycolor(
    actualWhiteLabel.primaryColour,
  )
    .lighten(15)
    .toString();

  return { whiteLabelSettings: actualWhiteLabel };
}
